<template>
  <div>
    <section
      id="sectionId"
      class="d-flex body-content new-addendee-list attendee_List"
      style="background-color: #f1f3f4"
    >
      <div class="container-fluid">
        <!----create new-session-popuop start------>
        <!-- The Modal -->
        <div class="crenew-session-popuop">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <!-- Modal Header -->
              <div class="register_popup">
                <div class="modal-header">
                  <h4 class="modal-title page-head">Create New Session</h4>
                </div>
              </div>

              <!-- Modal body -->
              <div class="modal-body">
                <div class="ss-cns-body-wrap">
                  <div
                    class="d-flex align-items-center l-text ss-str-clnt mb-5"
                  >
                    Streaming Client:
                    <input
                      type="radio"
                      id="streamingClient"
                      name="radio-group"
                      checked
                    />
                    <label for="streamingClient">Zoom</label>
                    <span
                      class="ss-info"
                      data-toggle="tooltip"
                      title="info Text"
                    >
                      <img
                        src="../assets/Images/reg-ico/info.svg"
                        alt="onair"
                      />
                    </span>
                    <input
                      type="radio"
                      id="streamingClient-2"
                      name="radio-group"
                    />
                    <label for="streamingClient-2">Web</label>
                    <span
                      class="ss-info"
                      data-toggle="tooltip"
                      title="info Text"
                    >
                      <img
                        src="../assets/Images/reg-ico/info.svg"
                        alt="onair"
                      />
                    </span>
                  </div>
                  <div class="form-group">
                    <label>Session Title*</label>
                    <input
                      type="Text"
                      class="form-control ss-cns-name"
                      placeholder="Enter Session Title"
                    />
                  </div>
                  <div class="form-group mb-0">
                    <label>Description (Optional)</label>
                    <textarea
                      type="Text"
                      class="form-control"
                      placeholder=""
                      cols="4"
                      rows="3"
                    ></textarea>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-md-4 pr-1">
                      <div class="form-group">
                        <label>Start on*</label>
                        <input
                          type="datetime-local"
                          class="form-control"
                          placeholder="Enter Session Title"
                        />
                      </div>
                    </div>
                    <div class="col-md-4 pl-1">
                      <div class="form-group">
                        <label>Ends on*</label>
                        <input
                          type="datetime-local"
                          class="form-control"
                          placeholder="Enter Session Title"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Select a Speaker*</label>
                        <select type="" class="form-control">
                          <option>Select</option>
                          <option>A</option>
                          <option>b</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Select a Host*</label>
                        <select type="" class="form-control">
                          <option>Select</option>
                          <option>A</option>
                          <option>b</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Session Visible for*</label>
                        <select type="" class="form-control">
                          <option>List of attendees</option>
                          <option>A</option>
                          <option>b</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Select Attendees*</label>
                        <select type="" class="form-control">
                          <option>Floyd</option>
                          <option>Mario</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="reg-page-tab-hld mt-4">
                    <div
                      class="d-flex align-items-center l-text reg-page-tab-hld"
                    >
                      Enable RTMP Stream
                      <label class="switch ml-3 mb-0"
                        ><input type="checkbox" checked="checked" /><span
                          class="slider round"
                        ></span>
                      </label>
                      <span
                        class="ss-info"
                        data-toggle="tooltip"
                        title="info Text"
                      >
                        <img
                          src="../assets/Images/reg-ico/info.svg"
                          alt="onair"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Modal footer -->
              <div class="modal-footer ss-cns-foo-btn">
                <v-btn Outlined color="warning">
                  Back to List
                </v-btn>
                <v-btn dark color="#1a73e8">
                  Save &amp; Continue
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <!----create new-session-popuop end------>
      </div>
    </section>
  </div>
  <!----------right attendee detail-------->
</template>

<script>
//import Vue from "vue";
export default {
  data() {
    return {
    };
  },
}
</script>